<template>
<div class="postList">
    <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>批量导入</span>
        </div>
        <div class="text item">
            功能介绍：使用excel快速导入进行住宅、车位、储藏室、商铺信息
        </div>
        <div class="text item">
            住宅当有多个业主时，请使用‘，‘隔开，多个电话，多个身份证都是’，‘隔开，来进行区分
        </div>
        <div class="text item">
            一次导入的数据不要太多，大量数据分批导入,一次导入尽量少于2万
        </div>
        <div class="text item">
           使用方法:
        </div>
        <div class="text item">
           1、下载excel模板文件录入信息
        </div>
        <div class="text item">
           2、选择类型是住宅、车位、储藏室或商铺
        </div>
        <div class="text item">
           3、上传excel导入(注意底部有四个表格，想导入那个拉到最前面或新建个单独的表格)
        </div>
        <div class="text item">
           格式要求：请根据模板信息进行填写
        </div>
        <v-divider></v-divider>
        <el-form label-width="86px" class="weiz">
            <el-form-item label="导入名称">
                <div class="kuang"><el-input v-model="form.Import_name" placeholder="请填写导入名称"></el-input></div>
            </el-form-item>
            <el-form-item label="选择项目">
              <el-select v-model="form.pindex_id" filterable placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择类型">
                <el-select v-model="form.type" placeholder="请选择类型">
                <el-option label="住宅" value="1"></el-option>
                <el-option label="车位" value="2"></el-option>
                <el-option label="储藏室" value="3"></el-option>
                <el-option label="商铺" value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="上传文件">
                <el-upload
                    class="upload-demo"
                    :action="url"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :on-success="handleAvatarSuccess"
                    accept=".xls,.xlsx"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                    :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary" class="texts">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传xls或xlsx文件，且不超过7M</div>
                </el-upload>
            </el-form-item>
        </el-form>
        <v-divider></v-divider>
        <el-row  class="weiz">
            <el-button type="primary" class="texts" @click="download">下载excel模板文件</el-button>
            <el-button type="primary" class="texts" @click="submit()" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">确定导入</el-button>
        </el-row>
    </el-card>
</div>
</template>

<script>
export default {
  name: 'pindexImport',
  data () {
    return {
        url:'',
        form:{
           Import_name:'',
           pindex_id:'',
           type:'',
           route:'',
        },
        options1: [
        {
          value: '',
          label: ''
        },],
        fileList: [],
        loading:false,
    }
  },
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel?"+"login_name="+login+"&token="+token;
    // console.log(this.url);
    this.$myhttp.get('admin/getHouse',{
        'Content-Type': 'application/json'
        }).then(backdata=>{ // 异步执行成功后
        this.options1 = backdata.data[0];
    });
  },
  methods: {
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      handlePreview(file) {
        // console.log(file);
      },
      //超过一个文件
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //删除
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //限制大小
      beforeAvatarUpload(file){
        const isLt7M = file.size / 1024 / 1024 < 8;
        if (!isLt7M) {
          this.$message.error('上传文件大小不能超过 8MB!');
        }
        return isLt7M;
      },
      handleAvatarSuccess(res, file){
        this.form.route = file.response[0];
      },
      //保存
      submit(){
        if(this.form.Import_name == ''){
          this.$Message.error('导入名称不能为空!');
          return false;
        }
        if(this.form.pindex_id == ''){
          this.$Message.error('项目不能为空!');
          return false;
        }
        if(this.form.type == ''){
          this.$Message.error('类型不能为空!');
          return false;
        }
        if(this.form.route == ''){
          this.$Message.error('文件不能为空!');
          return false;
        }
        this.loading=true;
        this.$myhttp.post('admin/houseExcelAdd',this.form,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
              if(backdata.data == 200){
                this.form={
                  Import_name:'',
                  pindex_id:'',
                  type:'',
                  route:'',
                };
                this.fileList = [];
                this.loading=false;
                this.$Message.success('提交成功!');
              }
          });
      },
      //下载模板
      download(){
        var url = this.$myhttp.defaults.baseURL+"/excel/"+'数据导入模板.xls';
        window.open(url)
      }
  },
  watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.path == "/pindex/Import"){
       //加载项目列表
        this.$myhttp.get('admin/getHouse',{
            'Content-Type': 'application/json'
            }).then(backdata=>{ // 异步执行成功后
            this.options1 = backdata.data[0];
        });
      }
    }
  },
}
</script>
<style scoped>
    .postList{
        margin: 1%;
        width: 100%;
    }
    .text {
        font-size: 14px;
    }

    .item {
        margin-bottom: 18px;
    }
    .clearfix{
        font-size: 16px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 98%;
    }
    .weiz{
        margin-top: 1%;
    }
    .kuang{
        width: 217px;
    }
    .texts{
        color: rgb(240, 236, 236);
    }
 
    
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Import.vue